import { useState, useContext, useCallback } from 'react'
import { ProductsContext } from '../context/products.context'

export function useCipModal() {
  const { currentCip, cipDoc, setCurrentCip, clearCipData } = useContext(ProductsContext)
  const [isOpen, setIsOpen] = useState(false)

  const openModal = useCallback((cipCode) => {
    if (currentCip === cipCode && cipDoc?.cipDetails) {
      setIsOpen(true)
      return
    }
    clearCipData()
    setCurrentCip(cipCode)
    setIsOpen(true)
  }, [currentCip, cipDoc, clearCipData, setCurrentCip])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    openModal,
    closeModal,
  }
}
